import Duck from "redux-ducks-ts"

export const expensiveba = new Duck("expensiveba", "cargo")
